import { render, staticRenderFns } from "./PromotionDetailApp2.vue?vue&type=template&id=49f1c484&scoped=true"
import script from "./PromotionDetailApp2.vue?vue&type=script&lang=js"
export * from "./PromotionDetailApp2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f1c484",
  null
  
)

export default component.exports